import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { addWalletResponseSchema } from '../types';

export type AddWalletMutationParams = {
	accountId: number;
	currency: string;
};

export const createAddWalletMutation = () =>
	createAuthMutation({
		params: declareParams<AddWalletMutationParams>(),
		request: {
			method: 'POST',
			url: '/account/wallet',
			body: (data) => data,
		},
		response: {
			contract: zodContract(addWalletResponseSchema),
		},
	});
